import { SET_TAX_INPUT_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const taxInputUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_TAX_INPUT_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default taxInputUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/TaxInputs/reducer.js